import React, { Component } from 'react';
import redArrow from '../assets/red-arrow.png';
import blueArrow from '../assets/blue-arrow.png';
import '../styles/Vote.css';
import candleYellow from '../assets/candle-yellow.gif';
import candleRed from '../assets/candle-red.gif';
import candleBlue from '../assets/candle-blue.gif';
import assetWeb from '../assets/spider-web.png';
import ghoul from '../assets/Ghoul.png';

export class VotingPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            CurrentVote: "NO",
            userVote: "NOT SET"
        };
        this.setVote = this.setVote.bind(this);
    }
   
    setVote(button_clicked) {
        const vote_for = button_clicked.target.value
        const userVote = JSON.stringify({
            "pollId": this.props.pollData.activePollId,
            "userId": this.props.pollData.userID,
            "userName": this.props.pollData.userName,
            "vote": vote_for
        });
        this.setState({
            CurrentVote: vote_for,
            userVote: userVote
        });
        fetch('api/Vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: userVote
        })
    }

    render() {
        return (
            <div class="page-content">
                <div class="arrow-choice-page">
                    <p className='hidden' aria-live="polite">
                        Current Vote: <strong>{this.state.CurrentVote}</strong>,
                        user_Vote = {this.state.userVote}
                    </p>
                    <h1 className="pt-10">What will you <br />do?</h1>
                    <div className="row triangle-selectors">
                        <div className="voting-item_container"><img className={'arrow arrow-bob ' + (this.state.CurrentVote === "B" ? "hide" : "")} src={redArrow} alt="red arrow" /></div>
                        <div className="voting-item_container"><img className={'arrow arrow-bob ' + (this.state.CurrentVote === "A" ? "hide" : "")} src={blueArrow} alt="blue arrow" /></div>
                    </div>
                    <div className="row">
                        <div className="voting-item_container"><button className="btn-vote btn-A" value="A" onClick={this.setVote} alt="triangle"></button></div>
                        <div className="voting-item_container"><button className="btn-vote btn-B" value="B" onClick={this.setVote} alt="circle" ></button></div>
                    </div>
                </div>
                    <img class="candle" src={candleYellow} alt="flickering red candle" hidden={!(this.state.CurrentVote === "NO")} />
                <img class="candle" src={candleRed} alt="flickering red candle" hidden={!(this.state.CurrentVote === "A")} />
                <img class="candle" src={candleBlue} alt="flickering blue candle" hidden={!(this.state.CurrentVote === "B")} />
            </div>
        );
    }
}


export class VotingNumberPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialedNumber: [],
            result: "",
            message: "Type the correct number?"
        };
        this.addNumber = this.addNumber.bind(this);
    }

    addNumber(number_dialed) {
        if (this.state.result === "") {
            const number_entered = number_dialed.target.value;
            var new_state = [...this.state.dialedNumber, number_entered]
            this.setState({ dialedNumber: new_state });
            var codeEntered = new_state.toString(); 

            let len = new_state.length;
            document.getElementById("dig" + (len - 1)).innerText = number_entered;

            if ((this.props.poleType === "Phone") && (len < 10)) { return }
            else if (len < 4) { return }

            if (
                ((this.props.poleType === "Computer") && (len === 4) && (codeEntered === "3,1,1,0")) 
                || ((this.props.poleType === "Door") && (len === 4) && (codeEntered === "6,6,4,5")) 
                || ((this.props.poleType === "Phone") && (len === 10) 
                    && (codeEntered === "0,1,5,0,3,2,0,6,6,6"))
            ) {
                this.setState({ result: "correct", message: "Well done, " + (this.props.pollData.userName) });
                this.send_result("B");
            } else {
                this.setState({ result: "wrong", message: "Oh dear, " + (this.props.pollData.userName) });
                this.send_result("A");
            }
        }
    }

    send_result(vote_for) {
        const userVote = JSON.stringify({
            "pollId": this.props.pollData.activePollId,
            "userId": this.props.pollData.userID,
            "userName": this.props.pollData.userName,
            "vote": vote_for
        });

        fetch('api/Vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: userVote
        })
        return true;
    }

    render() {
        let numbers = <p className={'numbers ' + (this.state.result)}></p>

        if (this.props.poleType === "Phone") {
            numbers =
                <p className={'numbers ' + (this.state.result)}>
                    <span id="dig0">_</span>
                    <span id="dig1">_</span>
                    <span id="dig2">_</span>
                    <span id="dig3">_</span>
                    <span id="dig4">_</span>
                    <span id="dig5">_</span>
                    <span id="dig6">_</span>
                    <span id="dig7">_</span>
                    <span id="dig8">_</span>
                    <span id="dig9">_</span>
                </p>
        } else {
            numbers =
                <p className={'numbers ' + (this.state.result)}>
                    <span id="dig0">_</span>
                    <span id="dig1">_</span>
                    <span id="dig2">_</span>
                    <span id="dig3">_</span>
                </p>
        }
        return (
            <div className="keypad-input_container page-content">
                <h1 className="pt-10">{( this.state.message )}</h1>
                {numbers}
                <div className="keypad">
                    <div className="keypad_button"><button value="7" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="7" >7</button></div>
                    <div className="keypad_button"><button value="8" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="8" >8</button></div>
                    <div className="keypad_button"><button value="9" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="9" >9</button></div>
                    <div className="keypad_button"><button value="4" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="4" >4</button></div>
                    <div className="keypad_button"><button value="5" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="5" >5</button></div>
                    <div className="keypad_button"><button value="6" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="6" >6</button></div>
                    <div className="keypad_button"><button value="1" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="1" >1</button></div>
                    <div className="keypad_button"><button value="2" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="2" >2</button></div>
                    <div className="keypad_button"><button value="3" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="3" >3</button></div>
                    <div className="keypad_button"><button value="." className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="." >.</button></div>
                    <div className="keypad_button"><button value="0" className={(this.state.result) + " btn-number"} onClick={this.addNumber} alt="0" >0</button></div>
                    <div className="keypad_button"><button className={(this.state.result) + " btn-number"} value="," onClick={this.addNumber} alt="," >,</button></div>
                </div>
            </div>
        );
    }
}

export class VotingSilencePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            noise: "quiet",
        };
        this.makeNoise = this.makeNoise.bind(this);
    }

    makeNoise() {
        this.setState({ noise: "loud" });
        fetch('api/Vote', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "pollId": this.props.pollData.activePollId,
                "userId": this.props.pollData.userID,
                "userName": this.props.pollData.userName,
                "vote": "A"
            })
        })
    }

    render() {
        return (
            <div className="quiet-page page-content">
                <h1>Stay Quiet</h1>
                <button className="btn btn-noise" onClick={this.makeNoise}>Don't Press</button>
                <img class="candle" src={candleYellow} alt="flickering yellow candle" />
                <div className={(this.state.noise === "quiet" ? "hide" : "ominous")}>
                    <div>
                        <img src={assetWeb} className="web-top" alt="web" />
                        <div class="ominous-content">
                            <h1 class="dont-press-message">I said don't press {this.props.pollData.userName}</h1>
                            <img src={ghoul} className="ghoul" alt="ghoul" />
                            <h1 class="cannot-be-undone-message">What is done cannot be undone...</h1>
                        </div>
                        <img class="candle" src={candleRed} alt="flickering red candle" />
                    </div>
                </div>
            </div>
        );
    }
}
